import { api } from './index';
function index(communeId) { const path = '/api/internal/commune_company_items'; return api({ method: 'get', url: path, params: { communeId } }).then(response => { var _response$data; return (_response$data = response.data) == null ? void 0 : _response$data.communeCompanyItems; }); }
export { index };
